// client/src/pages/Admin/ResourceManager/components/ResourceToolbar.tsx
import React from 'react';
import { Filter, ChevronDown, RotateCcw } from 'lucide-react';
import { ResourceSearch } from './ResourceSearch';
import { ResourceSort } from './ResourceSort';

interface ResourceToolbarProps {
  showFilters: boolean;
  onToggleFilters: () => void;
  activeFilterCount: number;
  hasActiveFilters: boolean;
  onResetFilters: () => void;
  sortOption: string;
  sortDirection: 'asc' | 'desc';
  onSortChange: (value: string) => void;
  onToggleSortDirection: () => void;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onClearSearch: () => void;
  isSearchFocused: boolean;
  onSearchFocus: () => void;
  onSearchBlur: () => void;
}

export const ResourceToolbar: React.FC<ResourceToolbarProps> = ({
  showFilters,
  onToggleFilters,
  activeFilterCount,
  hasActiveFilters,
  onResetFilters,
  sortOption,
  sortDirection,
  onSortChange,
  onToggleSortDirection,
  searchTerm,
  onSearchChange,
  onClearSearch,
  isSearchFocused,
  onSearchFocus,
  onSearchBlur
}) => {
  return (
    <div className="filter-bar">
      <div className="filter-bar-left">
        <button
          type="button"
          className={`filter-toggle ${showFilters ? 'active' : ''}`}
          onClick={onToggleFilters}
          aria-expanded={showFilters}
          aria-label="Toggle filters"
        >
          <Filter size={16} />
          <span>Filters</span>
          {activeFilterCount > 0 && (
            <span className="filter-badge">{activeFilterCount}</span>
          )}
          <ChevronDown size={16} className={`chevron ${showFilters ? 'rotated' : ''}`} />
        </button>

        {hasActiveFilters && (
          <button
            type="button"
            className="reset-filters-btn"
            onClick={onResetFilters}
            aria-label="Reset all filters"
          >
            <RotateCcw size={14} />
            <span>Reset</span>
          </button>
        )}
      </div>

      <div className="filter-bar-right">
        <ResourceSort
          sortOption={sortOption}
          sortDirection={sortDirection}
          onSortChange={onSortChange}
          onToggleDirection={onToggleSortDirection}
        />
        <ResourceSearch
          searchTerm={searchTerm}
          onSearchChange={onSearchChange}
          onClearSearch={onClearSearch}
          isFocused={isSearchFocused}
          onFocus={onSearchFocus}
          onBlur={onSearchBlur}
        />
      </div>
    </div>
  );
};